import styled from "styled-components"

export const DelimiterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const DelimiterWrapper = styled.div`
  width: 250px;
  text-align: center;
  border-bottom: 1px solid #EDEBE9;
  line-height: 0.1em;
  margin: 20px 0 15px;
`

export const DelimiterText = styled.span`
  background: #fff;
  padding: 0 10px;
`
